module.exports = "<app-user-group-list></app-user-group-list>\n"